"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whitelistMatcherContext = void 0;
var sets_1 = require("../../utils/lang/sets");
function whitelistMatcherContext(ruleAttr) {
    var whitelistSet = new sets_1._Set(ruleAttr);
    return function whitelistMatcher(runtimeAttr) {
        var isInWhitelist = whitelistSet.has(runtimeAttr);
        return isInWhitelist;
    };
}
exports.whitelistMatcherContext = whitelistMatcherContext;
